import api from "@/lib/api";

export const courseService = {
  generate: (payload) => api.post("/courses/generate", payload).then((r) => r.data),
  list: () => api.get("/courses").then((r) => r.data.courses),
  get: (id) => api.get(`/courses/${id}`).then((r) => r.data.course),
  remove: (id) => api.delete(`/courses/${id}`).then((r) => r.data),
  sectionAudio: (id, idx) => api.get(`/courses/${id}/audio/${idx}`).then((r) => r.data.audio),
  getCompletion: (id) => api.get(`/courses/${id}/completion`).then((r) => r.data),
  complete: (id) => api.post(`/courses/${id}/complete`).then((r) => r.data),
  getProgress: (id) => api.get(`/courses/${id}/progress`).then((r) => r.data),
  saveProgress: (id, sectionIdx, positionSeconds) =>
    api.post(`/courses/${id}/progress`, { section_idx: sectionIdx, position_seconds: positionSeconds }).then((r) => r.data),
  getContinue: () => api.get("/courses/continue").then((r) => r.data.course),
  askCourseQuestion: (id, question) =>
    api.post(`/courses/${id}/qa`, { question }).then((r) => r.data),
  claim: (guestSessionId) => api.post("/courses/claim", { guest_session_id: guestSessionId }).then((r) => r.data),
  downloadCertificate: async (id, title) => {
    const res = await api.get(`/courses/${id}/certificate`, { responseType: "blob" });
    const url = window.URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${(title || "certificate").replace(/[^a-z0-9]+/gi, "-")}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  },
};
